export default __webpack_public_path__ + "static/media/caret_down.12a52f72.svg";